import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

import { DefaultContent } from './components/DefaultContent';
import { useTokenSelectModal } from './useTokenSelectModal';

export const TokenSelectModal = () => {
  const isOpen = useTokenSelectModal((s) => s.isOpen);
  const closeModal = useTokenSelectModal((s) => s.closeModal);
  return (
    <Modal
      size="md"
      scrollBehavior="inside"
      onClose={closeModal}
      isOpen={isOpen}
    >
      <ModalOverlay />
      <ModalContent
        minH="500px"
        bg="linear-gradient(0deg, #152C4B 0%, #081020 100%)"
      >
        <ModalCloseButton />
        <DefaultContent />
      </ModalContent>
    </Modal>
  );
};
